export interface CelebrityPost {
  id: string;
  slug: string;
  name: string;
  nameEn: string;
  category: string;
  birthDate: string;
  birthTime?: string;
  birthPlace: string;
  thumbnail: string;
  summary: string;
  tags: string[];
  fourPillars: {
    year: { heavenly: string; earthly: string; element: string; animal: string };
    month: { heavenly: string; earthly: string; element: string; animal: string };
    day: { heavenly: string; earthly: string; element: string; animal: string };
    hour?: { heavenly: string; earthly: string; element: string; animal: string };
  };
  dayMaster: string;
  fiveElements: { wood: number; fire: number; earth: number; metal: number; water: number };
  astrology: {
    sun: string;
    moon: string;
    rising: string;
    description: string;
  };
  ziwei: {
    mainStar: string;
    palace: string;
    description: string;
  };
  sajuAnalysis: string;
  comprehensiveAnalysis: string;
  keyStrengths: string[];
  lifeAdvice: string;
  publishedAt: string;
  readTime: number;
}

export const celebrityPosts: CelebrityPost[] = [
  {
    id: '1',
    slug: 'elon-musk',
    name: '일론 머스크',
    nameEn: 'Elon Musk',
    category: '기업인',
    birthDate: '1971년 6월 28일',
    birthTime: '오전 7시 30분',
    birthPlace: '남아프리카 프리토리아',
    thumbnail: 'https://public.readdy.ai/ai/img_res/8a67bd148d9fba9dc6ebce9dfcf89c86.jpg',
    summary: '테슬라, 스페이스X, X를 이끄는 시대의 혁신가. 경(庚)금 일간의 강인함과 파괴적 창조력이 그의 모든 사업에 녹아있다.',
    tags: ['사주팔자', '점성술', '자미두수', '기업인', '혁신가'],
    fourPillars: {
      year: { heavenly: '신(辛)', earthly: '해(亥)', element: '금·수', animal: '돼지' },
      month: { heavenly: '경(庚)', earthly: '오(午)', element: '금·화', animal: '말' },
      day: { heavenly: '경(庚)', earthly: '오(午)', element: '금·화', animal: '말' },
      hour: { heavenly: '갑(甲)', earthly: '진(辰)', element: '목·토', animal: '용' },
    },
    dayMaster: '경(庚)금',
    fiveElements: { wood: 1, fire: 2, earth: 1, metal: 3, water: 1 },
    astrology: {
      sun: '게자리 (Cancer)',
      moon: '처녀자리 (Virgo)',
      rising: '전갈자리 (Scorpio)',
      description: '게자리 태양은 표면 아래 깊은 감수성과 집착적 몰입력을 부여한다. 전갈자리 상승궁은 변혁과 재생의 에너지로, 그가 기존 산업을 완전히 파괴하고 재건하는 성향을 설명한다. 처녀자리 달은 치밀한 디테일 집착과 완벽주의를 더한다.',
    },
    ziwei: {
      mainStar: '탐랑성(貪狼星)',
      palace: '명궁(命宮) — 사업·재물궁',
      description: '자미두수 명반의 탐랑성은 욕망, 개척, 다재다능함의 별로 불린다. 사업궁과 재물궁이 강하게 활성화되어 있어 여러 사업을 동시에 운영하며 모두에서 두각을 나타내는 능력이 타고나 있다.',
    },
    sajuAnalysis: '경(庚)금 일간은 원석이 아닌 단단히 제련된 금속을 상징한다. 강한 금기운이 2개의 오(午)화를 만나 불 속에서 단련되는 형국으로, 이는 엄청난 도전과 실패를 거치면서도 오히려 더 강해지는 머스크의 인생 패턴과 정확히 일치한다. 연지의 해(亥)수는 지혜와 통찰을, 시간의 갑(甲)목은 창조적 에너지의 분출구를 의미한다. 특히 금화교전(金火交戰)의 구조는 극단적 긴장감 속에서 최고의 성과를 내는 구조로, 페이팔 매각, 테슬라 파산 위기, 스페이스X 세 번의 발사 실패 등 모든 위기가 오히려 도약의 발판이 된 것이 이를 증명한다.',
    comprehensiveAnalysis: '일론 머스크의 사주, 점성술, 자미두수를 종합하면 \'파괴적 창조자\'의 전형을 보여준다. 경금 일간의 타고난 강직함과 개혁 성향이 전갈자리 상승궁의 변혁 에너지와 결합하여, 단순한 사업가가 아닌 시대를 재정의하는 존재가 된다. 탐랑성의 무한한 욕망과 다방면 재능이 우주, 전기차, AI, SNS라는 서로 다른 영역을 동시에 개척하게 하는 원동력이다. 2025-2030년은 대운이 토(土)기운으로 흐르며 금(金)을 생하는 시기로, 스페이스X 화성 유인 미션과 AI 사업이 폭발적 성과를 낼 것으로 분석된다.',
    keyStrengths: ['불굴의 실행력과 리스크 감수 능력', '여러 산업을 동시에 혁신하는 멀티태스킹', '위기를 기회로 전환하는 금화교전의 기질', '장기적 비전 설정과 집착적 목표 추구'],
    lifeAdvice: '경금의 지나친 강직함은 인간관계에 마찰을 일으킬 수 있다. 처녀자리 달의 과잉 분석을 게자리 태양의 공감 능력으로 균형 잡는 것이 리더십의 완성이다.',
    publishedAt: '2026-03-10',
    readTime: 8,
  },
  {
    id: '2',
    slug: 'donald-trump',
    name: '도널드 트럼프',
    nameEn: 'Donald Trump',
    category: '정치인',
    birthDate: '1946년 6월 14일',
    birthTime: '오전 10시 54분',
    birthPlace: '미국 뉴욕 퀸스',
    thumbnail: 'https://readdy.ai/api/search-image?query=dramatic%20portrait%20silhouette%20of%20a%20powerful%20political%20leader%20in%20front%20of%20American%20flag%20with%20dark%20stormy%20sky%20background%2C%20golden%20light%20illuminating%20from%20below%2C%20cinematic%20epic%20atmosphere%2C%20majestic%20presidential%20mood%2C%20dark%20dramatic%20editorial%20photography&width=800&height=500&seq=celeb2&orientation=landscape',
    summary: '두 번 대통령에 오른 전무후무한 정치 인생. 병(丙)화 일간의 강렬한 카리스마와 태양 같은 존재감이 모든 논란을 압도한다.',
    tags: ['사주팔자', '점성술', '자미두수', '정치인', '대통령'],
    fourPillars: {
      year: { heavenly: '병(丙)', earthly: '술(戌)', element: '화·토', animal: '개' },
      month: { heavenly: '경(庚)', earthly: '오(午)', element: '금·화', animal: '말' },
      day: { heavenly: '병(丙)', earthly: '자(子)', element: '화·수', animal: '쥐' },
      hour: { heavenly: '경(庚)', earthly: '오(午)', element: '금·화', animal: '말' },
    },
    dayMaster: '병(丙)화',
    fiveElements: { wood: 0, fire: 3, earth: 1, metal: 2, water: 1 },
    astrology: {
      sun: '쌍둥이자리 (Gemini)',
      moon: '사수자리 (Sagittarius)',
      rising: '사자자리 (Leo)',
      description: '쌍둥이자리 태양은 말의 천재성과 상황 반전 능력을 부여한다. 사자자리 상승궁은 절대적 존재감과 주목받고자 하는 욕구, 타고난 왕의 기질을 나타낸다. 사수자리 달은 극단적 발언과 낙관주의, 해외와의 인연을 의미한다.',
    },
    ziwei: {
      mainStar: '자미성(紫微星)',
      palace: '명궁(命宮) — 관록궁 동궁',
      description: '자미두수에서 자미성은 제왕의 별로 불린다. 관록궁(官祿宮)과 동궁에 위치하여 타고난 권력 지향성과 고위직에 오르는 운명을 나타낸다. 일반적으로 자미성을 타고난 인물은 최고 자리를 두 번 이상 경험하는 경우가 많다.',
    },
    sajuAnalysis: '병(丙)화 일간은 태양 그 자체다. 강렬하고 직접적이며, 자신을 중심으로 세상이 돌아야 한다고 믿는다. 일지의 자(子)수는 병화를 극(剋)하여 강한 긴장감을 형성하는데, 이는 끊임없는 위기와 공격을 받으면서도 더욱 극렬하게 타오르는 트럼프의 정치 인생과 맞닿아 있다. 연지의 술(戌)토와 시지의 오(午)화는 화토생금(火土生金) 구조를 이루어 재물과 권력 모두 강한 사주다. 두 개의 경(庚)금은 사주에서 \'관성(官星)\'으로, 공적 영역과 권위에 대한 집착을 상징한다.',
    comprehensiveAnalysis: '트럼프의 사주, 점성술, 자미두수는 한결같이 \'제왕의 기질\'을 가리킨다. 병화 일간의 뜨거운 에너지가 사자자리 상승궁의 왕 기질과 결합하고, 자미성이 명궁을 장악하여 세 가지 체계 모두에서 지도자의 운명을 가리킨다. 흥미로운 점은 병자(丙子)일주의 충(冲) 구조가 그의 인생 전반에 걸친 극적인 반전을 예고한다는 것이다. 2024년 대선 승리는 화기운이 절정에 달한 시기와 정확히 일치한다.',
    keyStrengths: ['천하를 뒤흔드는 연설력과 대중 호소력', '극도의 위기에서 반전하는 불사조 기질', '타고난 비즈니스 협상 감각', '사자자리 상승의 압도적 무대 존재감'],
    lifeAdvice: '병화의 지나친 자기 중심성이 연대와 협력을 방해할 수 있다. 쌍둥이자리 태양의 유연성을 발휘해 다양한 시각을 수용할 때 진정한 통합의 리더가 된다.',
    publishedAt: '2026-03-08',
    readTime: 9,
  },
  {
    id: '3',
    slug: 'warren-buffett',
    name: '워런 버핏',
    nameEn: 'Warren Buffett',
    category: '기업인',
    birthDate: '1930년 8월 30일',
    birthTime: '오후 3시',
    birthPlace: '미국 네브拉斯카 오마하',
    thumbnail: 'https://readdy.ai/api/search-image?query=wise%20elderly%20investor%20sitting%20in%20a%20classic%20wooden%20office%20surrounded%20by%20stacks%20of%20financial%20documents%2C%20warm%20amber%20golden%20light%20streaming%20through%20window%2C%20timeless%20elegant%20atmosphere%2C%20rich%20mahogany%20tones%2C%20Wall%20Street%20legacy%20vibes%2C%20sophisticated%20editorial%20photography&width=800&height=500&seq=celeb3&orientation=landscape',
    summary: '94세에도 현역인 오마하의 현인. 기(己)토 일간의 묵직한 축적 능력과 처녀자리의 정밀한 분석력이 복리의 마법을 만들어냈다.',
    tags: ['사주팔자', '점성술', '자미두수', '투자가', '장수운'],
    fourPillars: {
      year: { heavenly: '경(庚)', earthly: '오(午)', element: '금·화', animal: '말' },
      month: { heavenly: '무(戊)', earthly: '신(申)', element: '토·금', animal: '원숭이' },
      day: { heavenly: '기(己)', earthly: '해(亥)', element: '토·수', animal: '돼지' },
      hour: { heavenly: '경(庚)', earthly: '신(申)', element: '금·금', animal: '원숭이' },
    },
    dayMaster: '기(己)토',
    fiveElements: { wood: 0, fire: 1, earth: 2, metal: 4, water: 1 },
    astrology: {
      sun: '처녀자리 (Virgo)',
      moon: '사수자리 (Sagittarius)',
      rising: '염소자리 (Capricorn)',
      description: '처녀자리 태양은 숫자에 대한 타고난 감각, 실용적 사고, 세부 사항에 대한 집착을 부여한다. 염소자리 상승궁은 장기적 목표를 향한 인내와 복리의 마법을 믿는 능력의 근원이다. 사수자리 달은 투자에서의 철학적 접근과 인류에 대한 낙관적 믿음을 나타낸다.',
    },
    ziwei: {
      mainStar: '천상성(天相星)',
      palace: '명궁(命宮) — 재백궁 삼합',
      description: '천상성은 안정, 신중함, 장기 축적의 별이다. 재백궁(財帛宮)과 삼합 구조를 이루어 재물이 자연스럽게 모이고 지키는 능력이 탁월하다. 노년에 더욱 빛나는 후천 운의 구조로, 70대 이후 자선 사업에서 새로운 의미를 찾는 패턴도 이 명반에서 예측 가능하다.',
    },
    sajuAnalysis: '기(己)토 일간은 논밭의 흙이다. 비옥하고 포용력이 있으며, 무엇이든 받아들여 기르고 축적하는 힘이 있다. 일지의 해(亥)수는 재성(財星)으로, 재물이 일간 바로 옆에 붙어있는 형국이다. 이는 버핏이 어릴 때부터 돈에 대한 감각이 남달랐던 것을 설명한다. 4개의 금기운이 식상(食傷)으로 기토를 설기(洩氣)하는데, 이는 지식과 아이디어를 재물로 전환하는 능력, 즉 그의 투자 철학이 곧 돈이 되는 구조다. 경오(庚午)년의 화(火)는 기토를 생하여 지속적인 에너지를 공급한다.',
    comprehensiveAnalysis: '버핏의 세 가지 운명 체계를 종합하면 \'시간의 마스터\'가 핵심 키워드다. 기토 일간의 꾸준한 축적, 염소자리 상승의 장기 인내, 천상성의 안정적 재물 운이 완벽히 겹친다. 가장 놀라운 것은 그의 사주에서 조급함과 관련된 기운이 거의 없다는 점이다. 이 조합은 단기 이익보다 복리의 마법을 믿을 수밖에 없는 운명적 구조를 만들어낸다. 94세인 2024년 현재도 대운이 금(金)→수(水)로 흘러 여전히 활발한 투자 활동을 할 수 있는 에너지가 남아있다.',
    keyStrengths: ['시간을 자산으로 만드는 복리 철학', '숫자와 가치를 꿰뚫어보는 처녀자리의 분석력', '공포 속에서 매수하는 역발상 담력', '99%를 기부하는 기토의 포용과 베풂'],
    lifeAdvice: '기토의 지나친 안주 성향은 빠르게 변하는 기술 영역에서 맹점이 될 수 있다. 사수자리 달의 탐구 정신으로 새로운 영역에 적극적으로 발을 들이는 것이 필요하다.',
    publishedAt: '2026-03-05',
    readTime: 7,
  },
  {
    id: '4',
    slug: 'taylor-swift',
    name: '테일러 스위프트',
    nameEn: 'Taylor Swift',
    category: '연예인',
    birthDate: '1989년 12월 13일',
    birthTime: '오전 8시 36분',
    birthPlace: '미국 펜실베이니아 웨스트레딩',
    thumbnail: 'https://readdy.ai/api/search-image?query=ethereal%20pop%20star%20silhouette%20on%20a%20grand%20concert%20stage%20with%20purple%20and%20golden%20light%20beams%20streaming%20from%20above%2C%20sparkles%20and%20glitter%20floating%20in%20air%2C%20dramatic%20theatrical%20atmosphere%2C%20dark%20background%20with%20neon%20aurora%20glow%2C%20superstar%20performance%20aesthetic%20editorial%20photography&width=800&height=500&seq=celeb4&orientation=landscape',
    summary: '스포티파이 역사상 최다 스트리밍 아티스트. 임(壬)수 일간의 심오한 감성과 사수자리의 자유로운 영혼이 세대를 관통하는 음악을 만든다.',
    tags: ['사주팔자', '점성술', '자미두수', '연예인', '뮤지션'],
    fourPillars: {
      year: { heavenly: '기(己)', earthly: '사(巳)', element: '토·화', animal: '뱀' },
      month: { heavenly: '임(壬)', earthly: '자(子)', element: '수·수', animal: '쥐' },
      day: { heavenly: '임(壬)', earthly: '오(午)', element: '수·화', animal: '말' },
      hour: { heavenly: '갑(甲)', earthly: '진(辰)', element: '목·토', animal: '용' },
    },
    dayMaster: '임(壬)수',
    fiveElements: { wood: 1, fire: 2, earth: 2, metal: 0, water: 3 },
    astrology: {
      sun: '사수자리 (Sagittarius)',
      moon: '물고기자리 (Pisces)',
      rising: '전갈자리 (Scorpio)',
      description: '사수자리 태양은 모험, 자유, 철학적 스토리텔링의 에너지다. 그녀의 앨범이 항상 새로운 장르와 스타일을 탐험하는 이유다. 물고기자리 달은 깊은 감수성과 공감 능력, 가사 속 섬세한 감정 묘사의 근원이다. 전갈자리 상승궁은 변혁과 재탄생의 에너지로, 공개적인 갈등 후 더 강하게 복귀하는 패턴을 설명한다.',
    },
    ziwei: {
      mainStar: '천기성(天機星)',
      palace: '명궁(命宮) — 문창궁 협조',
      description: '천기성은 총명, 변화, 예술적 재능의 별이다. 문창궁(文昌宮)의 협조를 받아 글쓰기와 음악적 재능이 극대화된다. 천기성을 가진 인물은 끊임없이 자기 자신을 재창조하는 특성이 있으며, 대중의 감정을 읽고 연결하는 천부적 능력을 지닌다.',
    },
    sajuAnalysis: '임(壬)수 일간은 광활한 바다다. 깊고 감각적이며, 모든 것을 받아들이고 자신의 언어로 표현한다. 월간의 임자(壬子) 구조는 임수가 더욱 강해지는 \'득지(得地)\'의 형국으로, 음악적 감수성이 폭발적으로 넘친다. 일지의 오(午)화는 임수를 따뜻하게 하는 관성(官星)으로, 사랑과 연애에 깊이 빠져드는 성향과 그것이 예술로 승화되는 구조를 만든다. 임오(壬午)일주는 \'자유로운 영혼\'의 일주로, 규범과 틀을 거부하는 창의적 반항아의 기질이 있다.',
    comprehensiveAnalysis: '테일러 스위프트는 사주, 점성술, 자미두수 모두에서 \'예술적 변신의 아이콘\'을 가리킨다. 임수 일간의 광활한 감수성이 물고기자리 달의 공감 능력, 천기성의 재창조 에너지와 만나 시대마다 다른 모습으로 진화하면서도 본질을 잃지 않는 아티스트가 된다. 특히 전갈자리 상승궁과 임오일주의 화수상전(火水相戰) 구조는 공개적 논쟁 후 더욱 강해지는 \'적에게 감사하라\'의 인생 패턴과 정확히 맞아 떨어진다. 2025-2026년은 Eras Tour의 여진으로 재물운이 최고조에 달할 전망이다.',
    keyStrengths: ['개인적 경험을 보편적 감동으로 승화하는 능력', '공개적 갈등 후 완벽하게 재기하는 전갈자리 기질', '팬들과 깊은 정서적 유대를 형성하는 물고기자리 달', '끊임없이 자신을 재창조하는 천기성의 변화 에너지'],
    lifeAdvice: '임수의 지나친 감정 몰입은 경계선을 흐리게 할 수 있다. 사수자리 태양의 철학적 거리두기를 활용해 감정과 자아를 분리하는 연습이 장기적 행복에 중요하다.',
    publishedAt: '2026-03-03',
    readTime: 8,
  },
  {
    id: '5',
    slug: 'bts-rm',
    name: 'RM (방탄소년단)',
    nameEn: 'BTS RM',
    category: '연예인',
    birthDate: '1994년 9월 12일',
    birthTime: '오전 11시',
    birthPlace: '대한민국 경기도 일산',
    thumbnail: 'https://readdy.ai/api/search-image?query=artistic%20portrait%20of%20a%20young%20korean%20musician%20artist%20surrounded%20by%20floating%20abstract%20art%20pieces%20and%20music%20notes%2C%20dark%20studio%20background%20with%20neon%20purple%20and%20golden%20light%20beams%2C%20contemporary%20Korean%20wave%20aesthetic%2C%20modern%20editorial%20photography%20high%20fashion%20vibe&width=800&height=500&seq=celeb5&orientation=landscape',
    summary: 'BTS를 이끄는 리더이자 최고의 작사가. 계(癸)수 일간의 예리한 통찰과 처녀자리의 완벽주의가 세계를 움직이는 가사를 탄생시킨다.',
    tags: ['사주팔자', '점성술', '자미두수', '연예인', 'K-POP'],
    fourPillars: {
      year: { heavenly: '갑(甲)', earthly: '술(戌)', element: '목·토', animal: '개' },
      month: { heavenly: '신(辛)', earthly: '유(酉)', element: '금·금', animal: '닭' },
      day: { heavenly: '계(癸)', earthly: '축(丑)', element: '수·토', animal: '소' },
      hour: { heavenly: '무(戊)', earthly: '오(午)', element: '토·화', animal: '말' },
    },
    dayMaster: '계(癸)수',
    fiveElements: { wood: 1, fire: 1, earth: 3, metal: 2, water: 1 },
    astrology: {
      sun: '처녀자리 (Virgo)',
      moon: '물병자리 (Aquarius)',
      rising: '전갈자리 (Scorpio)',
      description: '처녀자리 태양은 완벽주의적 작업 방식과 세밀한 언어 감각의 근원이다. 물병자리 달은 인류애와 집단 의식에 대한 관심, UN 연설로 이어지는 사회적 메시지 추구를 나타낸다. 전갈자리 상승궁은 예술 안에 깊은 변혁의 메시지를 담는 성향과 연관된다.',
    },
    ziwei: {
      mainStar: '문곡성(文曲星)',
      palace: '명궁(命宮) — 문창성 동궁',
      description: '문곡성은 글쓰기, 언어, 예술적 표현의 별이다. 문창성(文昌星)과 동궁하여 이중의 언어 재능을 부여받았다. 이 명반은 예술적 재능이 단순한 오락을 넘어 사회적 영향력을 행사하는 구조로, 시대적 목소리가 되는 예술가의 운명을 나타낸다.',
    },
    sajuAnalysis: '계(癸)수 일간은 안개비, 샘물, 지하수처럼 스미는 물이다. 임수(壬水)가 바다처럼 웅장하다면 계수는 작지만 어디든 파고드는 예리함을 가진다. 월간의 신유(辛酉) 금 기운이 계수를 생하여 지적 에너지가 끊임없이 충전되는 구조다. 일지의 축(丑)토는 계수의 뿌리이자 냉습한 환경을 만들어 내면 깊은 곳에서 끄집어내는 사유의 힘을 준다. 갑술(甲戌)년의 목(木)은 계수를 설기하여 자신의 에너지를 세상으로 표출하고자 하는 강한 욕구를 나타낸다.',
    comprehensiveAnalysis: 'RM의 운명 분석을 종합하면 \'세대의 목소리\'라는 키워드가 도출된다. 계수 일간의 스며드는 영향력, 처녀자리 태양의 정교한 언어 감각, 문곡성+문창성의 이중 언어 재능이 삼중으로 겹쳐 타고난 작사가이자 사상가의 운명을 만든다. 물병자리 달의 인류애는 그의 음악이 개인의 감정을 넘어 사회적 메시지가 되는 이유를 설명한다. 솔로 활동 이후의 운세는 예술가로서 더욱 성숙하고 깊어지는 2030년대를 향하고 있다.',
    keyStrengths: ['IQ 148의 지적 능력과 언어적 감수성', '물병자리 달의 사회 변혁에 대한 진정성', '처녀자리 완벽주의로 만들어지는 정교한 가사', 'UN 무대까지 이어지는 타고난 공공 커뮤니케이션 능력'],
    lifeAdvice: '계수의 내면 지향성은 때로 지나친 자기 비판으로 이어질 수 있다. 물병자리 달의 객관적 시각으로 자신을 바라보며, 불완전함 속에서도 앞으로 나아가는 용기가 필요하다.',
    publishedAt: '2026-02-28',
    readTime: 7,
  },
  {
    id: '6',
    slug: 'steve-jobs',
    name: '스티브 잡스',
    nameEn: 'Steve Jobs',
    category: '기업인',
    birthDate: '1955년 2월 24일',
    birthTime: '오후 7시 15분',
    birthPlace: '미국 캘리포니아 샌프란시스코',
    thumbnail: 'https://readdy.ai/api/search-image?query=visionary%20tech%20pioneer%20silhouette%20against%20glowing%20apple-like%20orb%20of%20light%20in%20a%20dark%20minimalist%20room%2C%20clean%20zen%20aesthetic%2C%20dramatic%20single%20spotlight%20from%20above%2C%20warm%20amber%20and%20white%20light%20contrast%2C%20iconic%20minimalist%20design%20philosophy%20atmosphere%2C%20cinematic%20editorial%20photography&width=800&height=500&seq=celeb6&orientation=landscape',
    summary: '\'다르게 생각하라\'를 실천한 디지털 혁명의 아버지. 을(乙)목 일간의 강인한 생명력과 물고기자리의 직관이 현대 기술 미학을 창조했다.',
    tags: ['사주팔자', '점성술', '자미두수', '기업인', '혁신가'],
    fourPillars: {
      year: { heavenly: '을(乙)', earthly: '미(未)', element: '목·토', animal: '양' },
      month: { heavenly: '갑(甲)', earthly: '인(寅)', element: '목·목', animal: '호랑이' },
      day: { heavenly: '을(乙)', earthly: '해(亥)', element: '목·수', animal: '돼지' },
      hour: { heavenly: '신(辛)', earthly: '유(酉)', element: '금·금', animal: '닭' },
    },
    dayMaster: '을(乙)목',
    fiveElements: { wood: 1, fire: 2, earth: 1, metal: 3, water: 1 },
    astrology: {
      sun: '물고기자리 (Pisces)',
      moon: '쌍둥이자리 (Gemini)',
      rising: '처녀자리 (Virgo)',
      description: '물고기자리 태양은 현실과 이상을 넘나드는 직관적 비전의 근원이다. 처녀자리 상승궁은 완벽한 디자인과 기능의 통합을 추구하는 완벽주의를 부여한다. 쌍둥이자리 달은 키노트 연설에서의 탁월한 스토리텔링과 청중을 사로잡는 커뮤니케이션 능력의 원천이다.',
    },
    ziwei: {
      mainStar: '파군성(破軍星)',
      palace: '명궁(命宮) — 천마성 동행',
      description: '파군성은 파괴와 창조를 동시에 상징하는 가장 혁신적인 별이다. 천마성(天馬星)과 동행하여 전례 없는 새로운 영역을 개척하는 에너지가 극대화된다. 파군성을 가진 인물은 기존의 것을 완전히 부수고 새로운 패러다임을 만드는 운명을 타고난다.',
    },
    sajuAnalysis: '을(乙)목 일간은 담쟁이덩굴처럼 어떤 환경에서도 살아남아 아름다움을 창조하는 힘이 있다. 연월에 목(木)기운이 넘쳐 과강(過强)한 것처럼 보이지만, 시간의 신유(辛酉) 금기운이 관성(官星)으로 작용하여 강한 창의적 에너지를 규율과 완성도로 다듬는다. 이것이 잡스의 \'아름다운 엄격함\'이다. 일지의 해(亥)수는 인성(印星)으로 끊임없는 배움과 동양 철학, 선불교에 대한 깊은 관심을 나타낸다. 갑인(甲寅)월의 목기운은 기존 비즈니스 질서에 대한 강렬한 반발심을 설명한다.',
    comprehensiveAnalysis: '스티브 잡스의 운명 분석을 종합하면 \'파괴적 미학의 창조자\'다. 을목 일간의 아름다운 생존 본능이 물고기자리 태양의 비현실적 비전, 파군성의 파괴적 창조 에너지와 만나 \'불가능한 것을 가능하게 만드는\' 능력이 탄생한다. 처녀자리 상승궁의 완벽주의가 물고기자리의 이상주의를 현실 제품으로 구현시킨다. 56세의 이른 타계는 을목 과강(過强)의 사주에서 화(火)기운이 너무 부족하여 에너지를 발산하지 못하고 내부에서 소진되는 구조에서 예측되는 패턴이다.',
    keyStrengths: ['기술과 인문학의 교차점에서 제품을 창조하는 직관', '처녀자리의 디테일 완벽주의와 물고기자리의 거대한 비전', '파군성의 기존 패러다임 완전 파괴 능력', '담쟁이덩굴처럼 역경 속에서 피어나는 생명력'],
    lifeAdvice: '을목의 과강과 화기운 부족은 자기 소진의 위험을 내포한다. 쌍둥이자리 달의 가벼운 유머 감각을 허용하고, 완벽함을 내려놓는 순간들을 의도적으로 만드는 것이 건강과 행복에 필수적이다.',
    publishedAt: '2026-02-20',
    readTime: 9,
  },
  {
    id: '7',
    slug: 'oprah-winfrey',
    name: '오프라 윈프리',
    nameEn: 'Oprah Winfrey',
    category: '방송인',
    birthDate: '1954년 1월 29일',
    birthTime: '오전 4시 30분',
    birthPlace: '미국 미시시피 코시우스코',
    thumbnail: 'https://readdy.ai/api/search-image?query=powerful%20inspirational%20woman%20silhouette%20on%20a%20grand%20television%20talk%20show%20stage%20with%20warm%20golden%20spotlights%20and%20dramatic%20stage%20lighting%2C%20rich%20burgundy%20and%20gold%20color%20palette%2C%20empowerment%20and%20media%20mogul%20atmosphere%2C%20cinematic%20editorial%20photography%20strong%20composition&width=800&height=500&seq=celeb7&orientation=landscape',
    summary: '세상에서 가장 영향력 있는 방송인. 갑(甲)목 일간의 우뚝 선 리더십과 물병자리의 인류애가 TV 역사상 가장 공감 능력 있는 진행자를 만들었다.',
    tags: ['사주팔자', '점성술', '자미두수', '방송인', '리더십'],
    fourPillars: {
      year: { heavenly: '갑(甲)', earthly: '오(午)', element: '목·화', animal: '말' },
      month: { heavenly: '계(癸)', earthly: '축(丑)', element: '수·토', animal: '소' },
      day: { heavenly: '갑(甲)', earthly: '오(午)', element: '목·화', animal: '말' },
      hour: { heavenly: '병(丙)', earthly: '인(寅)', element: '화·목', animal: '호랑이' },
    },
    dayMaster: '갑(甲)목',
    fiveElements: { wood: 3, fire: 3, earth: 1, metal: 0, water: 1 },
    astrology: {
      sun: '물병자리 (Aquarius)',
      moon: '사수자리 (Sagittarius)',
      rising: '사수자리 (Sagittarius)',
      description: '물병자리 태양은 인류 전체에 대한 사랑과 개인의 성장을 돕는 강한 사명감의 원천이다. 사수자리 달과 상승궁의 이중 배치는 철학적 낙관주의, 글로벌 영향력, 끊임없는 배움에 대한 욕구를 나타낸다. 이 조합은 교육과 영감을 통해 세상을 변화시키는 사명을 타고난 영혼을 나타낸다.',
    },
    ziwei: {
      mainStar: '태양성(太陽星)',
      palace: '명궁(命宮) — 관록궁 조회',
      description: '태양성은 빛, 나눔, 공공의 영향력을 상징하는 별이다. 관록궁(官祿宮)의 조회를 받아 공적인 영역에서 무한한 빛을 발하는 구조다. 태양성을 가진 인물은 자신의 빛으로 주변을 따뜻하게 하고, 대중에게 희망을 주는 것이 천명이다.',
    },
    sajuAnalysis: '갑(甲)목 일간은 하늘을 향해 곧게 뻗은 나무다. 권위와 독립, 그리고 타인을 이끄는 것이 본능이다. 연일 두 개의 오(午)화가 갑목을 설기(洩氣)하여 에너지가 외부로 활발히 발산되는 구조로, 이것이 방송을 통해 세상에 빛을 전하는 오프라의 삶의 방식이다. 월간의 계(癸)수는 인성(印星)으로 끊임없는 독서와 배움, 그리고 정신적 성장에 대한 열망을 나타낸다. 시간의 병인(丙寅)은 갑목과 병화가 함께 어우러져 리더십과 카리스마가 폭발하는 강력한 시 기둥이다.',
    comprehensiveAnalysis: '오프라의 운명 분석을 종합하면 \'빛을 나누는 자\'라는 키워드가 완벽히 들어맞는다. 갑목 일간의 우뚝 선 리더십, 물병자리 태양의 인류애, 태양성의 공적 영향력이 삼중으로 겹쳐 단순한 방송인을 넘어 시대의 정신적 지도자가 되는 운명을 만든다. 가난한 흑인 여성에서 미디어 제국을 건설한 것은 갑오(甲午)일주의 에너지가 불꽃처럼 타오르는 특성에서 예견된 결과다. 70대 이후 교육과 자선 사업으로 새로운 전성기가 온다.',
    keyStrengths: ['공감과 취약성 공유를 통한 타인 치유 능력', '물병자리의 사회 변혁에 대한 진정성 있는 헌신', '갑목의 역경 속 불굴의 성장 에너지', '사수자리 이중 배치의 글로벌 영향력과 철학적 깊이'],
    lifeAdvice: '갑목의 지나친 독립성과 고집은 협력을 어렵게 만들 수 있다. 물병자리 태양의 집단 지혜를 신뢰하고, 혼자 모든 것을 짊어지려는 충동을 내려놓을 때 더 큰 임팩트가 만들어진다.',
    publishedAt: '2026-02-15',
    readTime: 8,
  },
  {
    id: '8',
    slug: 'son-heung-min',
    name: '손흥민',
    nameEn: 'Son Heung-min',
    category: '스포츠',
    birthDate: '1992년 7월 8일',
    birthTime: '오전 6시',
    birthPlace: '대한민국 강원도 춘천',
    thumbnail: 'https://readdy.ai/api/search-image?query=elite%20korean%20football%20soccer%20player%20silhouette%20celebrating%20a%20goal%20on%20a%20massive%20stadium%20filled%20with%20colored%20lights%20and%20fireworks%2C%20green%20pitch%20glowing%20under%20bright%20floodlights%2C%20dynamic%20athletic%20victory%20atmosphere%2C%20cinematic%20sports%20photography%20dramatic%20composition&width=800&height=500&seq=celeb8&orientation=landscape',
    summary: '아시아 최고의 축구 선수이자 토트넘의 레전드. 신(辛)금 일간의 빛나는 재능과 게자리의 집요한 목표 의식이 불가능한 것을 가능하게 만든다.',
    tags: ['사주팔자', '점성술', '자미두수', '스포츠', '축구'],
    fourPillars: {
      year: { heavenly: '임(壬)', earthly: '신(申)', element: '수·금', animal: '원숭이' },
      month: { heavenly: '계(癸)', earthly: '미(未)', element: '수·토', animal: '양' },
      day: { heavenly: '신(辛)', earthly: '해(亥)', element: '금·수', animal: '돼지' },
      hour: { heavenly: '갑(甲)', earthly: '자(子)', element: '목·수', animal: '쥐' },
    },
    dayMaster: '신(辛)금',
    fiveElements: { wood: 1, fire: 0, earth: 1, metal: 2, water: 4 },
    astrology: {
      sun: '게자리 (Cancer)',
      moon: '양자리 (Aries)',
      rising: '쌍둥이자리 (Gemini)',
      description: '게자리 태양은 가족과 조국에 대한 깊은 애착, 집요한 목표 추구의 근원이다. 양자리 달은 경기 중 폭발적인 에너지와 선제적 드리블, 위험한 상황에서도 뛰어드는 공격 본능을 나타낸다. 쌍둥이자리 상승궁은 팬들과 미디어와의 유쾌한 소통 능력과 빠른 적응력을 부여한다.',
    },
    ziwei: {
      mainStar: '무곡성(武曲星)',
      palace: '명궁(命宮) — 천부성 조회',
      description: '무곡성은 재물, 용기, 행동력의 별이다. 스포츠와 무예에서 두각을 나타내는 성질을 가지며, 천부성(天府星)의 조회를 받아 재능이 안정적으로 발전하고 경제적 품요로움이 따라온다. 이 명반은 스포츠를 통해 재물과 명예 모두를 얻는 운명을 나타낸다.',
    },
    sajuAnalysis: '신(辛)금 일간은 세공된 보석, 예리한 칼날이다. 재능이 있되 노력으로 더욱 빛나는 유형이다. 연간의 임신(壬申), 월간의 계미(癸未)가 수(水)기운을 품부하게 공급하여 신금이 빛을 발하는 환경이 갖춰진다. 이는 좋은 팀 환경(특히 케인, 에릭센 같은 조력자)에서 최고의 퍼포먼스를 보이는 패턴과 일치한다. 일지의 해(亥)수는 식상(食傷)으로 창의적인 골 결정력과 드리블 기술을 의미한다. 부친의 훈련으로 완성된 것은 갑자(甲子) 시주의 인성(印星) 강화 덕분이다.',
    comprehensiveAnalysis: '손흥민의 운명 분석을 종합하면 \'노력으로 빛나는 보석\'이 핵심 키워드다. 신금 일간의 타고난 재능, 양자리 달의 공격 본능, 무곡성의 스포츠 재물 운이 겹쳐 아시아 축구 역사를 새로 쓰는 운명을 만든다. 게자리 태양의 조국 사랑이 태극마크에 대한 헌신으로 이어지고, 이것이 오히려 그를 더욱 사랑받게 만드는 역설이 사주에 내재되어 있다. 2026 월드컵은 대운의 흐름상 최고의 무대가 될 것으로 분석된다.',
    keyStrengths: ['99골을 넣을 때까지 멈추지 않는 게자리의 집요함', '양자리 달의 경기 중 폭발적인 공격 전환 능력', '어떤 팀에서도 빛나는 신금의 적응력', '부친과의 유대에서 비롯된 굳건한 자기 훈련'],
    lifeAdvice: '신금의 지나친 자기 비판은 부상 후 회복 과정에서 심리적 부담이 될 수 있다. 게자리 태양의 자기 돌봄 능력을 활성화하여 신체와 정신 모두의 회복 시간을 존중하는 것이 선수 생명 연장의 열쇠다.',
    publishedAt: '2026-02-10',
    readTime: 7,
  },
  {
    id: '9',
    slug: 'iu',
    name: '아이유',
    nameEn: 'IU',
    category: '연예인',
    birthDate: '1993년 5월 16일',
    birthTime: '오전 8시 00분',
    birthPlace: '대한민국 서울시 성동구',
    thumbnail: 'https://readdy.ai/api/search-image?query=beautiful%20korean%20female%20singer%20silhouette%20on%20a%20dreamy%20cherry%20blossom%20stage%20with%20soft%20pink%20and%20golden%20light%20particles%20floating%20in%20air%2C%20romantic%20ethereal%20atmosphere%2C%20delicate%20pastel%20colors%2C%20K-pop%20idol%20goddess%20aesthetic%2C%20cinematic%20editorial%20photography%20whimsical%20fantasy&width=800&height=500&seq=celeb9&orientation=landscape',
    summary: '대한민국 역대 최고의 솔로 아티스트. 경(庚)금 일간의 완벽한 재능과 황소자리의 끈질긴 예술 혼이 국민 가수를 넘어 시대의 아이콘이 되게 했다.',
    tags: ['사주팔자', '점성술', '자미두수', '연예인', 'K-POP', '국민가수'],
    fourPillars: {
      year: { heavenly: '계(癸)', earthly: '유(酉)', element: '수·금', animal: '닭' },
      month: { heavenly: '신(辛)', earthly: '사(巳)', element: '금·화', animal: '뱀' },
      day: { heavenly: '경(庚)', earthly: '인(寅)', element: '금·목', animal: '호랑이' },
      hour: { heavenly: '갑(甲)', earthly: '진(辰)', element: '목·토', animal: '용' },
    },
    dayMaster: '경(庚)금',
    fiveElements: { wood: 2, fire: 1, earth: 1, metal: 3, water: 1 },
    astrology: {
      sun: '황소자리 (Taurus)',
      moon: '물병자리 (Aquarius)',
      rising: '쌍둥이자리 (Gemini)',
      description: '황소자리 태양은 예술에 대한 깊은 감각, 아름다움 추구, 완성될 때까지 포기하지 않는 집요함의 근원이다. 쌍둥이자리 상승궁은 연기와 음악을 자유롭게 넘나드는 다재다능함과 밝은 소통 능력을 부여한다. 물병자리 달은 시대를 앞서가는 독창적 음악 세계관의 근원이다.',
    },
    ziwei: {
      mainStar: '태음성(太陰星)',
      palace: '명궁(命宮) — 문창성 동궁',
      description: '태음성은 예술, 감수성, 아름다움의 여신별이다. 문창성(文昌星)과 동궁하여 음악과 문학적 재능이 극대화된다. 태음성을 가진 인물은 대중의 감성을 부드럽게 어루만지는 능력이 타고나며, 시간이 흐를수록 더욱 성숙하고 깊어지는 예술 세계를 구축한다.',
    },
    sajuAnalysis: '경(庚)금 일간은 정제된 금속이다. 일지의 인(寅)목은 관성(官星)으로 경금을 단련하는 대장간의 불꽃 역할을 한다. 이것이 어린 나이에 홀로 상경해 극도의 연습으로 자신을 갈고 닦은 아이유의 성장 스토리와 정확히 맞아떨어진다. 연간의 계유(癸酉)는 인성과 금기운이 겹쳐 끊임없이 자신을 개발하는 학습 욕구를 나타내며, 시간의 갑진(甲辰)은 창의적 에너지의 분출을 의미한다. 경인(庚寅)일주는 \'숨겨진 능력이 폭발하는\' 일주로, 처음에는 과소평가받다가 결국 업계 최정상에 서는 패턴을 가진다.',
    comprehensiveAnalysis: '아이유의 운명 분석을 종합하면 \'스스로를 만들어낸 예술가\'가 핵심 키워드다. 경금 일간의 자기 단련, 황소자리 태양의 집요한 예술 추구, 태음성의 대중 감성 연결이 삼중으로 겹쳐 국민 가수의 운명을 만든다. 특히 경인일주의 관성 구조는 아이유가 단순한 가수를 넘어 연기자, 작사가, 프로듀서로 끊임없이 영역을 확장하는 이유를 설명한다. 2026-2030년 대운은 창작의 전성기로, 역대 최고 앨범이 이 시기에 탄생할 가능성이 높다.',
    keyStrengths: ['무명에서 정상까지 스스로를 조각한 경금의 자기 단련력', '황소자리의 완성도에 대한 집착과 타협 없는 음악 철학', '태음성의 대중 감성을 정확히 건드리는 공감 능력', '음악·연기·작사·프로듀싱을 아우르는 멀티 재능'],
    lifeAdvice: '경금의 자기 기준이 너무 높으면 스스로에게 가혹해질 수 있다. 황소자리 태양의 자기 돌봄 능력을 활성화하여 신체와 정신 모두의 회복 시간을 존중하는 것이 창작의 원천이 된다.',
    publishedAt: '2026-03-15',
    readTime: 8,
  },
  {
    id: '10',
    slug: 'blackpink-jisoo',
    name: '블랙핑크 지수',
    nameEn: 'BLACKPINK Jisoo',
    category: '연예인',
    birthDate: '1995년 1월 3일',
    birthTime: '오전 9시 00분',
    birthPlace: '대한민국 경기도 고양시',
    thumbnail: 'https://readdy.ai/api/search-image?query=stunning%20korean%20female%20idol%20silhouette%20in%20a%20luxurious%20dark%20rose%20and%20black%20aesthetic%20setting%20with%20red%20rose%20petals%20floating%20around%2C%20dramatic%20high%20fashion%20editorial%20atmosphere%2C%20dark%20vogue%20magazine%20style%2C%20moody%20rich%20colors%20deep%20red%20and%20black%20contrast%2C%20cinematic%20lighting&width=800&height=500&seq=celeb10&orientation=landscape',
    summary: '블랙핑크의 맏언니이자 최고의 비주얼. 기(己)토 일간의 포용력과 염소자리의 탄탄한 자기 관리가 배우 겸 가수로서의 독보적 커리어를 만든다.',
    tags: ['사주팔자', '점성술', '자미두수', '연예인', 'K-POP', 'BLACKPINK'],
    fourPillars: {
      year: { heavenly: '을(乙)', earthly: '해(亥)', element: '목·수', animal: '돼지' },
      month: { heavenly: '임(壬)', earthly: '자(子)', element: '수·수', animal: '쥐' },
      day: { heavenly: '기(己)', earthly: '사(巳)', element: '토·화', animal: '뱀' },
      hour: { heavenly: '갑(甲)', earthly: '술(戌)', element: '목·토', animal: '개' },
    },
    dayMaster: '기(己)토',
    fiveElements: { wood: 2, fire: 1, earth: 2, metal: 0, water: 3 },
    astrology: {
      sun: '염소자리 (Capricorn)',
      moon: '처녀자리 (Virgo)',
      rising: '물고기자리 (Pisces)',
      description: '염소자리 태양은 체계적인 자기 관리와 장기적 커리어 구축의 원동력이다. 물고기자리 상승궁은 무대 위에서 발산하는 몽환적이고 신비로운 매력의 근원이다. 처녀자리 달은 세심한 디테일 관리와 완벽한 무대 준비를 향한 집착을 나타낸다.',
    },
    ziwei: {
      mainStar: '천부성(天府星)',
      palace: '명궁(命宮) — 태음성 조회',
      description: '천부성은 안정, 품격, 자연스러운 귀기(貴氣)의 별이다. 태음성(太陰星)의 조회를 받아 예술적 감수성이 더해진다. 이 명반은 어떤 환경에서도 흔들리지 않는 내면의 중심과 함께, 대중에게 자연스럽게 사랑받는 운명을 나타낸다.',
    },
    sajuAnalysis: '기(己)토 일간은 부드럽고 포용적인 대지의 흙이다. 연간과 월간에 수(水)기운이 넘치는데, 이는 기토가 물을 머금어 비옥해지는 구조다. 이것이 지수가 어떤 역할이든 자연스럽게 소화하는 능력과 연결된다. 일지의 사(巳)화는 비겁(比劫)이자 식신(食神)의 역할을 하여 자신감과 표현력을 강화한다. 기사(己巳)일주는 \'숨겨진 화려함\'의 일주로, 처음에는 조용해 보이지만 자신의 영역에서 강렬하게 빛나는 특성이 있다.',
    comprehensiveAnalysis: '지수의 운명 분석을 종합하면 \'천연의 귀기를 타고난 예술가\'다. 기토 일간의 자연스러운 포용력, 염소자리 태양의 꾸준한 자기 관리, 천부성의 타고난 품격이 결합하여 노력 없이 빛나는 것처럼 보이지만 실제로는 치밀한 준비의 결과물인 매력을 만든다. 2024년 시작한 솔로 활동과 배우로서의 커리어는 2027년 이후 더욱 전성기를 맞이할 것으로 분석된다.',
    keyStrengths: ['어떤 포맷에서도 자연스럽게 빛나는 기토의 포용 매력', '염소자리의 흔들림 없는 자기 관리와 프로 정신', '물고기자리 상승궁의 신비롭고 몽환적인 무대 매력', '그룹 내 큰언니로서의 안정적 리더십'],
    lifeAdvice: '기토의 과한 배려심은 자신의 필요와 경계를 잃게 만들 수 있다. 염소자리 태양의 자기 우선순위 설정 능력으로, 나 자신을 먼저 챙기는 것이 더 오래, 더 잘 남을 챙길 수 있는 비결이다.',
    publishedAt: '2026-03-14',
    readTime: 7,
  },
  {
    id: '11',
    slug: 'kim-yuna',
    name: '김연아',
    nameEn: 'Kim Yuna',
    category: '스포츠',
    birthDate: '1990년 9월 5일',
    birthTime: '오전 7시 00분',
    birthPlace: '대한민국 경기도 부천시',
    thumbnail: 'https://readdy.ai/api/search-image?query=graceful%20figure%20skater%20silhouette%20spinning%20on%20gleaming%20ice%20rink%20with%20crystalline%20light%20refractions%20and%20ice%20sparkles%2C%20royal%20blue%20and%20silver%20color%20palette%2C%20majestic%20Olympic%20champion%20atmosphere%2C%20elegant%20motion%20blur%20effects%2C%20cinematic%20sports%20photography%20with%20ethereal%20winter%20fantasy%20aesthetic&width=800&height=500&seq=celeb11&orientation=landscape',
    summary: '피겨 스케이팅의 살아있는 전설. 갑(甲)목 일간의 우뚝 선 기개와 처녀자리의 완벽주의가 역대 최고점수를 달성한 피겨 여왕을 만들었다.',
    tags: ['사주팔자', '점성술', '자미두수', '스포츠', '피겨스케이팅', '올림픽'],
    fourPillars: {
      year: { heavenly: '경(庚)', earthly: '오(午)', element: '금·화', animal: '말' },
      month: { heavenly: '신(辛)', earthly: '유(酉)', element: '금·금', animal: '닭' },
      day: { heavenly: '갑(甲)', earthly: '신(申)', element: '목·금', animal: '원숭이' },
      hour: { heavenly: '갑(甲)', earthly: '인(寅)', element: '목·목', animal: '호랑이' },
    },
    dayMaster: '갑(甲)목',
    fiveElements: { wood: 3, fire: 1, earth: 0, metal: 4, water: 0 },
    astrology: {
      sun: '처녀자리 (Virgo)',
      moon: '사자자리 (Leo)',
      rising: '천칭자리 (Libra)',
      description: '처녀자리 태양은 1000번의 연습에도 완벽한 기술을 요구하는 집요한 완벽주의의 원천이다. 사자자리 달은 올림픽 무대에서 폭발하는 압도적 퍼포먼스와 \'빙판 위의 여왕\' 기질을 나타낸다. 천칭자리 상승궁은 예술과 스포츠의 경계를 넘나드는 우아한 미적 감각을 부여한다.',
    },
    ziwei: {
      mainStar: '칠살성(七殺星)',
      palace: '명궁(命宮) — 화권성 동궁',
      description: '칠살성은 경쟁, 극복, 전사의 에너지를 가진 별이다. 화권성(化權星)과 동궁하여 경쟁적 상황에서 권위와 지배력을 발휘하는 능력이 극대화된다. 이 명반은 강력한 경쟁자들을 모두 제압하고 정상에 서는 운명을 나타내며, 은퇴 후에도 영향력이 지속되는 구조다.',
    },
    sajuAnalysis: '갑(甲)목 일간은 하늘을 향해 뻗은 나무다. 일지의 신(申)금과 월지의 유(酉)금이 관성(官星)으로 갑목을 극(剋)하는 구조인데, 이것이 바로 바로 최고의 적수들과 경쟁하면서 오히려 더 빛나는 김연아의 경쟁 패턴이다. 연지의 오(午)화가 화극금(火剋金)으로 관성을 제압하는 모습은 \'나를 이기려는 모든 것을 결국 내가 제압한다\'는 운명 구조다. 시주의 갑인(甲寅) 목기운은 일간을 강화하여 어린 나이에도 두려움 없이 세계 무대에 서게 하는 담력을 부여한다.',
    comprehensiveAnalysis: '김연아의 운명 분석을 종합하면 \'불가능을 현실로 만든 완벽주의자\'다. 갑목 일간의 불굴의 기개, 처녀자리 태양의 완벽주의, 칠살성+화권성의 최강 경쟁력이 삼중으로 겹쳐 역대 최고 피겨 선수의 운명을 만든다. 특히 갑신(甲申)일주의 편관(偏官) 구조는 \'강한 적수가 있을수록 더 강해진다\'는 특성을 가지며, 아사다 마오와의 라이벌 구도가 오히려 김연아를 역대 최고점으로 이끈 것이 이를 증명한다.',
    keyStrengths: ['연습과 완벽함에 대한 처녀자리의 절대 타협 불가 기준', '올림픽 빙판 위에서 폭발하는 사자자리 달의 무대 장악력', '강한 압박 속에서 더 빛나는 갑신일주의 경쟁 본능', '빙판 위 예술과 운동의 완벽한 통합'],
    lifeAdvice: '갑목 과강(過强)과 화기운 부족은 자신을 소진시키는 경향이 있다. 사자자리 달의 놀이와 창의적 즐거움을 허용하고, 완벽함이 아닌 기쁨을 위해 스케이팅을 즐기는 순간을 만드는 것이 중요하다.',
    publishedAt: '2026-03-13',
    readTime: 8,
  },
  {
    id: '12',
    slug: 'bong-joon-ho',
    name: '봉준호',
    nameEn: 'Bong Joon-ho',
    category: '감독',
    birthDate: '1969년 9월 14일',
    birthTime: '오전 6시 30분',
    birthPlace: '대한민국 대구시',
    thumbnail: 'https://readdy.ai/api/search-image?query=visionary%20film%20director%20silhouette%20behind%20a%20movie%20camera%20on%20a%20cinematic%20studio%20set%20with%20dramatic%20chiaroscuro%20lighting%2C%20film%20noir%20aesthetic%20with%20golden%20directorial%20spotlight%2C%20dark%20atmospheric%20background%20with%20scattered%20film%20reels%20and%20clapperboards%2C%20Oscar%20statuette%20glow%2C%20sophisticated%20cinematic%20editorial%20photography&width=800&height=500&seq=celeb12&orientation=landscape',
    summary: '오스카를 정복한 기생충의 아버지. 기(己)토 일간의 깊은 통찰과 처녀자리의 날카로운 사회 분석이 할리우드를 뒤흔든 한국 영화를 탄생시켰다.',
    tags: ['사주팔자', '점성술', '자미두수', '감독', '영화', '오스카'],
    fourPillars: {
      year: { heavenly: '기(己)', earthly: '유(酉)', element: '토·금', animal: '닭' },
      month: { heavenly: '신(辛)', earthly: '유(酉)', element: '금·금', animal: '닭' },
      day: { heavenly: '기(己)', earthly: '해(亥)', element: '토·수', animal: '돼지' },
      hour: { heavenly: '갑(甲)', earthly: '인(寅)', element: '목·목', animal: '호랑이' },
    },
    dayMaster: '기(己)토',
    fiveElements: { wood: 2, fire: 0, earth: 2, metal: 3, water: 1 },
    astrology: {
      sun: '처녀자리 (Virgo)',
      moon: '전갈자리 (Scorpio)',
      rising: '전갈자리 (Scorpio)',
      description: '처녀자리 태양은 사회 모순과 계급 불평등을 외과의사처럼 해부하는 날카로운 분석력의 근원이다. 전갈자리 달과 상승궁의 이중 배치는 인간 심리의 어두운 면을 직시하고 이를 예술로 승화하는 능력, 그리고 한 번 목표를 정하면 절대 포기하지 않는 집착적 몰입력을 나타낸다.',
    },
    ziwei: {
      mainStar: '거문성(巨門星)',
      palace: '명궁(命宮) — 화과성 동궁',
      description: '거문성은 언어, 논쟁, 심층 탐구의 별이다. 화과성(化科星)과 동궁하여 학문적 명성과 예술적 평가가 극도로 높아지는 구조다. 이 명반은 세상의 어두운 진실을 언어와 예술로 드러내어 시대적 담론을 이끄는 사상가적 예술가의 운명을 나타낸다.',
    },
    sajuAnalysis: '기(己)토 일간은 깊이 파고들면 금광을 품고 있는 대지다. 연월의 신유(辛酉) 이중 금기운이 식상(食傷)으로 기토를 설기하여 창작 에너지가 외부로 폭발적으로 분출되는 구조다. 이것이 봉준호 감독의 왕성한 창작 욕구와 다작의 원동력이다. 일지의 해(亥)수는 재성(財星)으로 창작이 곧 재물이 되는 사주 구조다. 시간의 갑인(甲寅) 관성은 공적 영역과 명예에 대한 강한 지향성을 나타내며, 오스카 수상은 이 관성이 발동한 결과다.',
    comprehensiveAnalysis: '봉준호의 운명 분석을 종합하면 \'사회의 이면을 예술로 해부하는 거장\'이다. 기토 일간의 깊은 통찰, 처녀자리+전갈자리 이중 분석력, 거문성의 언어적 예술 재능이 결합하여 단순한 오락을 넘어 사회적 메시지를 담은 세계적 걸작을 탄생시킨다. 기생충의 오스카 4관왕은 대운의 금기운이 최고조에 달한 2020년에 일어난 것으로, 사주학적으로 완벽한 타이밍이었다. 2026-2032년 다음 대운에서 또 하나의 역사적 작품이 탄생할 것으로 분석된다.',
    keyStrengths: ['사회 계급과 모순을 날카롭게 포착하는 처녀자리 분석력', '인간의 어두운 심리를 예술로 승화하는 전갈자리 이중 깊이', '기토의 비옥한 창작 에너지와 끊임없는 아이디어 생성력', '할리우드를 정복한 거문성의 언어적 설득력과 스토리텔링'],
    lifeAdvice: '전갈자리 이중 배치는 모든 것에 깊이 파고드는 집착으로 자신을 소진시킬 수 있다. 기토의 포용력으로 불완전함도 예술의 일부로 받아들이며, 창작의 즐거움 자체를 잊지 않는 것이 중요하다.',
    publishedAt: '2026-03-12',
    readTime: 8,
  },
  {
    id: '13',
    slug: 'lee-hyori',
    name: '이효리',
    nameEn: 'Lee Hyori',
    category: '연예인',
    birthDate: '1979년 5월 10일',
    birthTime: '오전 10시 00분',
    birthPlace: '대한민국 경기도 화성시',
    thumbnail: 'https://readdy.ai/api/search-image?query=iconic%20Korean%20female%20celebrity%20silhouette%20in%20a%20powerful%20sexy%20stage%20performance%20with%20red%20and%20golden%20fire%20sparks%20around%2C%20dark%20stage%20with%20dramatic%20spotlight%2C%20fierce%20and%20bold%20energy%2C%20legendary%20pop%20diva%20atmosphere%2C%20cinematic%20concert%20photography%20with%20intense%20emotion%20and%20charisma&width=800&height=500&seq=celeb13&orientation=landscape',
    summary: '20년을 뛰어넘어 여전히 정상인 국민 디바. 갑(甲)목 일간의 불굴의 생명력과 황소자리의 강렬한 예술 혼이 대한민국 섹시 아이콘의 전설을 만든다.',
    tags: ['사주팔자', '점성술', '자미두수', '연예인', '디바', '레전드'],
    fourPillars: {
      year: { heavenly: '갑(甲)', earthly: '미(未)', element: '목·토', animal: '양' },
      month: { heavenly: '계(癸)', earthly: '사(巳)', element: '수·화', animal: '뱀' },
      day: { heavenly: '갑(甲)', earthly: '술(戌)', element: '목·토', animal: '개' },
      hour: { heavenly: '무(戊)', earthly: '오(午)', element: '토·화', animal: '말' },
    },
    dayMaster: '갑(甲)목',
    fiveElements: { wood: 1, fire: 2, earth: 4, metal: 0, water: 1 },
    astrology: {
      sun: '황소자리 (Taurus)',
      moon: '물병자리 (Aquarius)',
      rising: '처녀자리 (Virgo)',
      description: '황소자리 태양은 육체적 표현에 대한 본능적 재능과 감각적 예술에 대한 깊은 헌신을 나타낸다. 물병자리 달은 시대를 앞서가는 자유로운 정신과 나이를 거스르는 혁신적 태도의 근원이다. 처녀자리 상승궁은 무대 위 완벽한 퍼포먼스를 위한 치밀한 준비와 프로 정신을 부여한다.',
    },
    ziwei: {
      mainStar: '태양성(太陽星)',
      palace: '명궁(命宮) — 관록궁 조회',
      description: '태양성은 빛, 나눔, 공공의 영향력을 상징하는 별이다. 관록궁(官祿宮)의 조회를 받아 공적인 영역에서 무한한 빛을 발하는 구조다. 태양성을 가진 인물은 자신의 빛으로 주변을 따뜻하게 하고, 대중에게 희망을 주는 것이 천명이다.',
    },
    sajuAnalysis: '갑(甲)목 일간은 시간이 갈수록 더 단단해지는 나무다. 연일 토(土)기운이 두텁게 깔려 관성(官星)이 강한 사주인데, 이는 사회적 규범과 관습에 얽매이지 않고 오히려 이를 뒤흔들어 트렌드를 만드는 이효리의 기질과 맞닿아있다. 월간의 계사(癸巳)는 화수충(火水衝) 구조를 포함하여 에너지가 폭발적으로 발산되는 형상이다. 갑술(甲戌)일주는 \'매력의 저장고\'로 불리는 일주로, 오랜 세월이 지나도 매력이 사라지지 않는 구조다.',
    comprehensiveAnalysis: '이효리의 운명 분석을 종합하면 \'시간이 갈수록 강해지는 레전드\'다. 갑목 일간의 불굴의 생명력, 황소자리 태양의 영원한 예술 혼, 태양성의 공적 영향력이 삼중으로 결합하여 20년이 넘도록 정상을 유지하는 운명을 만든다. 특히 갑술일주의 매력 저장고 특성은 40대 이후에도 오히려 더 강한 존재감을 발산하는 것을 사주학적으로 설명한다.',
    keyStrengths: ['나이를 거스르는 물병자리 달의 혁신적 자유 정신', '갑목의 어떤 역경에도 꺾이지 않는 불굴의 생명력', '태양성+황소자리의 자력(磁力) 같은 대중 흡인력', '20년 이상 트렌드를 만들어내는 황소자리의 예술 직관'],
    lifeAdvice: '갑목과 탐랑성의 조합은 끊임없이 새로운 자극을 추구하게 만든다. 황소자리 태양의 깊은 내면 연결을 통해 외부의 인정보다 자기 자신과의 평화로운 관계를 구축하는 것이 장기적 행복의 열쇠다.',
    publishedAt: '2026-03-11',
    readTime: 7,
  },
  {
    id: '14',
    slug: 'bts-v',
    name: 'V (방탄소년단)',
    nameEn: 'BTS V (Kim Taehyung)',
    category: '연예인',
    birthDate: '1995년 12월 30일',
    birthTime: '오전 11시 00분',
    birthPlace: '대한민국 대구시 수성구',
    thumbnail: 'https://readdy.ai/api/search-image?query=ethereal%20korean%20male%20artist%20silhouette%20in%20an%20atmospheric%20art%20gallery%20setting%20with%20vintage%20paintings%20and%20golden%20candlelight%2C%20dark%20romantic%20atmosphere%20with%20floating%20musical%20notes%20and%20rose%20petals%2C%20artistic%20renaissance%20aesthetic%20meets%20modern%20K-pop%2C%20mysterious%20and%20sensual%20editorial%20photography&width=800&height=500&seq=celeb14&orientation=landscape',
    summary: '음악과 미술을 넘나드는 예술가적 영혼. 경(庚)금 일간의 독특한 재능과 염소자리의 심오한 예술 세계관이 가장 개성 강한 BTS 멤버를 만들었다.',
    tags: ['사주팔자', '점성술', '자미두수', '연예인', 'K-POP', 'BTS'],
    fourPillars: {
      year: { heavenly: '을(乙)', earthly: '해(亥)', element: '목·수', animal: '돼지' },
      month: { heavenly: '임(壬)', earthly: '자(子)', element: '수·수', animal: '쥐' },
      day: { heavenly: '경(庚)', earthly: '술(戌)', element: '금·토', animal: '개' },
      hour: { heavenly: '무(戊)', earthly: '오(午)', element: '토·화', animal: '말' },
    },
    dayMaster: '경(庚)금',
    fiveElements: { wood: 1, fire: 1, earth: 2, metal: 1, water: 3 },
    astrology: {
      sun: '염소자리 (Capricorn)',
      moon: '양자리 (Aries)',
      rising: '천칭자리 (Libra)',
      description: '염소자리 태양은 예술 세계에 대한 진지한 탐구와 독자적인 미학 세계 구축의 원동력이다. 천칭자리 상승궁은 타고난 미적 감각과 어떤 환경에서도 조화롭고 아름답게 보이는 비주얼 능력의 근원이다. 양자리 달은 무대 위에서 폭발하는 즉흥적 에너지와 두려움 없는 예술적 실험을 나타낸다.',
    },
    ziwei: {
      mainStar: '천량성(天梁星)',
      palace: '명궁(命宮) — 화록성 동궁',
      description: '천량성은 고아한 품격, 예술적 감수성, 타인을 위로하는 능력의 별이다. 화록성(化祿星)과 동궁하여 예술로 인한 품요로움과 대중의 사랑을 끊임없이 받는 구조다. 이 명반은 예술가로서의 사명감이 강하며, 음악 이상의 예술적 영역으로 확장하는 운명을 나타낸다.',
    },
    sajuAnalysis: '경(庚)금 일간은 정제된 예술 작품 같은 금속이다. 연월의 수(水)기운이 경금을 빛나게 씻어주는 구조로, 타고난 비주얼과 예술적 감각이 시간이 갈수록 더욱 세련되는 형상이다. 일지의 술(戌)토는 경금의 뿌리로 안정감을 주되, 술토 안에는 오화(午火)의 기운이 숨어있어 겉으로는 차분해 보이지만 내면에는 강렬한 예술 열정이 숨어있다. 경술(庚戌)일주는 \'보석을 감춘 흙\'의 일주로, 발굴될수록 더 귀한 가치가 드러나는 유형이다.',
    comprehensiveAnalysis: 'V의 운명 분석을 종합하면 \'르네상스적 예술가\'가 핵심 키워드다. 경금 일간의 정제된 재능, 염소자리 태양의 진지한 예술 세계 구축, 천량성의 고아한 품격이 결합하여 음악·미술·패션·향수까지 아우르는 다방면 예술가의 운명을 만든다. 솔로 활동에서 발표한 앨범 Layover의 성공은 경금이 수기운을 만나 빛나는 구조가 발현된 것으로, 2026년 이후 대운의 흐름에서 더욱 깊은 예술 세계로 나아갈 것이 예측된다.',
    keyStrengths: ['음악·미술·패션을 아우르는 경금의 다방면 예술 재능', '염소자리의 트렌드보다 자신만의 세계를 만드는 독자적 미학', '천량성의 타인을 위로하고 감동시키는 공감 예술 능력', '천칭자리 상승궁의 타고난 비주얼 완벽성'],
    lifeAdvice: '경금의 자기 기준이 너무 높으면 스스로에게 가혹해질 수 있다. 양자리 달의 즉흥적 에너지를 믿고, 완벽한 준비 없이 현재 순간을 있는 그대로 즐기는 자유를 허락하는 것이 창작의 원천이 된다.',
    publishedAt: '2026-03-09',
    readTime: 7,
  },
  {
    id: '15',
    slug: 'yoo-jae-suk',
    name: '유재석',
    nameEn: 'Yoo Jae-suk',
    category: '방송인',
    birthDate: '1972년 8월 14일',
    birthTime: '오전 7시 00분',
    birthPlace: '대한민국 서울시',
    thumbnail: 'https://readdy.ai/api/search-image?query=beloved%20Korean%20TV%20host%20celebrity%20silhouette%20on%20a%20bright%20colorful%20variety%20show%20stage%20with%20confetti%20raining%20down%20and%20crowd%20cheering%20in%20background%2C%20warm%20joyful%20atmosphere%20with%20spotlights%2C%20entertainment%20kingpin%20national%20hero%20energy%2C%20cinematic%20television%20broadcasting%20photography%20with%20vibrant%20golden%20and%20warm%20tones&width=800&height=500&seq=celeb15&orientation=landscape',
    summary: '20년 연속 국민 MC의 자리를 지키는 연예계의 국보. 임(壬)수 일간의 지혜로운 포용력과 사자자리의 압도적 무대 장악력이 시대를 초월한 국민 MC를 만들었다.',
    tags: ['사주팔자', '점성술', '자미두수', '방송인', 'MC', '국민MC'],
    fourPillars: {
      year: { heavenly: '임(壬)', earthly: '자(子)', element: '수·수', animal: '쥐' },
      month: { heavenly: '갑(甲)', earthly: '신(申)', element: '목·금', animal: '원숭이' },
      day: { heavenly: '임(壬)', earthly: '오(午)', element: '수·화', animal: '말' },
      hour: { heavenly: '갑(甲)', earthly: '인(寅)', element: '목·목', animal: '호랑이' },
    },
    dayMaster: '임(壬)수',
    fiveElements: { wood: 3, fire: 1, earth: 0, metal: 1, water: 3 },
    astrology: {
      sun: '사자자리 (Leo)',
      moon: '물병자리 (Aquarius)',
      rising: '처녀자리 (Virgo)',
      description: '사자자리 태양은 무대의 중심에서 모든 에너지를 끌어당기는 타고난 주인공 기질의 원천이다. 물병자리 달과 사자자리 태양의 정반대 배치는 자신이 빛나면서도 공동체 전체를 빛나게 하는 특이한 리더십을 만든다. 처녀자리 상승궁은 수십 년간 한결같은 프로 정신과 세심한 배려의 근원이다.',
    },
    ziwei: {
      mainStar: '천동성(天同星)',
      palace: '명궁(命宮) — 화록성 조회',
      description: '천동성은 복(福), 즐거움, 모두를 행복하게 만드는 에너지의 별이다. 화록성(化祿星)의 조회를 받아 하는 모든 것에서 품요로움과 행운이 따라오는 구조다. 이 명반은 예술가로서의 사명감이 강하며, 음악 이상의 예술적 영역으로 확장하는 운명을 나타낸다.',
    },
    sajuAnalysis: '임(壬)수 일간은 광활한 바다다. 깊고 감각적이며, 모든 것을 받아들이고 자신의 언어로 표현한다. 월간의 임자(壬子) 구조는 임수가 더욱 강해지는 \'득지(得地)\'의 형국으로, 음악적 감수성이 폭발적으로 넘친다. 일지의 오(午)화는 임수를 따뜻하게 하는 관성(官星)으로, 사랑과 연애에 깊이 빠져드는 성향과 그것이 예술로 승화되는 구조를 만든다. 임오(壬午)일주는 \'자유로운 영혼\'의 일주로, 규범과 틀을 거부하는 창의적 반항아의 기질이 있다.',
    comprehensiveAnalysis: '유재석의 운명 분석을 종합하면 \'진정한 복의 별을 타고난 국민 MC\'다. 임수 일간의 무한한 포용력, 사자자리 태양의 꾸준한 자기 관리, 천동성의 타고난 품격이 결합하여 20년 국민 MC의 운명을 만든다. 특히 물병자리 달의 \'모두를 위한\' 정신이 자신이 빛나면서도 상대를 더 빛나게 하는 독특한 MC 스타일의 근원이다. 2026년 이후에도 대운이 목(木)→화(火)로 흘러 임수가 더욱 활발해지는 전성기가 계속될 전망이다.',
    keyStrengths: ['30년 한결같은 처녀자리 상승궁의 프로 정신과 성실함', '자신이 빛나면서 상대를 더 빛나게 하는 임수의 포용 리더십', '천동성의 타고난 복과 대중에게 행복을 전파하는 사명', '물과 불이 공존하는 임오일주의 긴장과 유머의 절묘한 균형'],
    lifeAdvice: '임수의 지나친 감정 몰입은 경계선을 흐리게 할 수 있다. 사수자리 태양의 철학적 거리두기를 활용해 감정과 자아를 분리하는 연습이 장기적 행복에 중요하다.',
    publishedAt: '2026-03-07',
    readTime: 8,
  },
  {
    id: '16',
    slug: 'park-ji-sung',
    name: '박지성',
    nameEn: 'Park Ji-sung',
    category: '스포츠',
    birthDate: '1981년 2월 25일',
    birthTime: '오전 8시 00분',
    birthPlace: '대한민국 경기도 수원시',
    thumbnail: 'https://readdy.ai/api/search-image?query=legendary%20Korean%20football%20player%20silhouette%20sprinting%20with%20the%20ball%20in%20an%20iconic%20Premier%20League%20stadium%20with%20red%20Manchester%20United%20atmosphere%2C%20vibrant%20red%20and%20white%20colors%2C%20roaring%20crowd%20in%20background%2C%20epic%20sports%20legacy%20photography%2C%20dramatic%20stadium%20floodlights%20cinematic%20composition&width=800&height=500&seq=celeb16&orientation=landscape',
    summary: '맨유의 레전드이자 한국 축구의 아이콘. 경(庚)금 일간의 강인한 체력과 물고기자리의 희생적 헌신이 3대 프리미어리그 우승을 이룬 불굴의 선수를 만들었다.',
    tags: ['사주팔자', '점성술', '자미두수', '스포츠', '축구', '맨유'],
    fourPillars: {
      year: { heavenly: '신(辛)', earthly: '유(酉)', element: '금·금', animal: '닭' },
      month: { heavenly: '경(庚)', earthly: '인(寅)', element: '금·목', animal: '호랑이' },
      day: { heavenly: '경(庚)', earthly: '오(午)', element: '금·화', animal: '말' },
      hour: { heavenly: '갑(甲)', earthly: '진(辰)', element: '목·토', animal: '용' },
    },
    dayMaster: '경(庚)금',
    fiveElements: { wood: 2, fire: 1, earth: 1, metal: 4, water: 0 },
    astrology: {
      sun: '물고기자리 (Pisces)',
      moon: '쌍둥이자리 (Gemini)',
      rising: '양자리 (Aries)',
      description: '물고기자리 태양은 팀을 위해 자신의 역할을 완전히 헌신하는 이타적 희생 정신의 원천이다. 박지성이 화려한 개인 기록보다 팀 승리에 집중한 이유다. 양자리 상승궁은 넘치는 체력과 전방 압박의 끝없는 에너지 근원이다. 쌍둥이자리 달은 좌우 어느 포지션에서도 뛸 수 있는 놀라운 적응력을 나타낸다.',
    },
    ziwei: {
      mainStar: '무곡성(武曲星)',
      palace: '명궁(命宮) — 천마성 동행',
      description: '무곡성은 강인한 체력, 실행력, 스포츠적 재능의 별이다. 천마성(天馬星)과 동행하여 해외에서 크게 성공하는 이역만리(異域萬里)의 운명을 나타낸다. 이 명반은 외국에서 인정받고 재물과 명예를 동시에 얻는 구조로, 맨체스터에서의 성공이 이를 완벽히 증명한다.',
    },
    sajuAnalysis: '경(庚)금 일간은 강철 같은 인내와 실행력의 상징이다. 연월의 신유(辛酉) 금기운까지 더해진 금기운 과강(過强) 사주로, 체력과 지구력이 비범하다. 일지의 오(午)화가 금화교전(金火交戰)을 이루어 강한 압박과 경쟁 속에서 오히려 더 빛나는 구조다. 이것이 92년 한일전 설욕골, 2002 월드컵 4강, 챔피언스리그 우승까지 모두 극도의 압박 상황에서 최고의 퍼포먼스를 보인 박지성의 특성과 일치한다. 시간의 갑진(甲辰)은 해외(천마)와의 인연을 나타내는 기운으로, 맨유 행이 운명이었음을 알 수 있다.',
    comprehensiveAnalysis: '박지성의 운명 분석을 종합하면 \'헌신으로 역사를 만든 불굴의 전사\'다. 경금 일간의 강철 체력, 물고기자리 태양의 팀을 위해 희생 정신, 무곡성+천마성의 해외 성공 운명이 결합하여 한국 축구 역사상 최고의 해외 파이터를 만들었다. 퍼거슨 감독이 그를 \'산소 탱크\'라고 부른 것은 경금 과강 사주의 지칠 줄 모르는 에너지를 정확히 표현한 것이다.',
    keyStrengths: ['물고기자리 태양의 완전한 팀 헌신과 이타적 희생 정신', '경금 과강의 90분 내내 지치지 않는 비범한 체력', '천마성의 이역만리에서 더 빛나는 해외 성공 운명', '압박 속에서 더 강해지는 금화교전의 경쟁 본능'],
    lifeAdvice: '경금의 지나친 헌신과 물고기자리의 자기 희생은 자신의 한계를 무시하게 만들 수 있다. 이제는 무릎 부상의 교훈처럼, 나 자신을 먼저 보살피는 것이 더 오래 빛날 수 있는 비결이다.',
    publishedAt: '2026-03-06',
    readTime: 7,
  },
];

export const categories = ['전체', '기업인', '정치인', '연예인', '방송인', '스포츠', '감독'];
